import { render, staticRenderFns } from "./Crisis_measurement.vue?vue&type=template&id=07535d1e"
import script from "./Crisis_measurement.vue?vue&type=script&lang=js"
export * from "./Crisis_measurement.vue?vue&type=script&lang=js"
import style0 from "./Crisis_measurement.vue?vue&type=style&index=0&id=07535d1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports